import { Button, Input, Modal, Select } from "antd";
import { useEffect, useRef } from "react";

const { Option } = Select;

const HomeBillDialog = ({
  homeDetailsOpen,
  setHomeDetailsOpen,
  qty,
  setQty,
  amount,
  setAmount,
  disCount,
  setDisCount,
  rate,
  setRate,
  disAmt,
  setDisAmt,
  productName,
  setProductName,
  designCode,
  setDesignCode,
  setPTypeName,
  setHsnCode,
  productData,
  setProductData,
  setBrandName,
  handleHomeBillSave,
}) => {
  const productRef = useRef(null);
  const designRef = useRef(null);
  const rateRef = useRef(null);
  const disPerRef = useRef(null);
  const disAmtRef = useRef(null);
  const saveRef = useRef(null);
  const handelCancel = () => {
    setHomeDetailsOpen(false);
    setQty(0);
    setAmount(0);
    setDisCount(0);
    setRate(0);
    setDisAmt(0);
    setProductName("");
    setDesignCode("");
    setPTypeName("");
    setHsnCode("");
    setBrandName("");
    setProductData([]);
  };
  useEffect(() => {
    if (homeDetailsOpen && productRef.current) {
      productRef.current.focus();
    }
  }, [homeDetailsOpen]);

  const handleProductChange = (value) => {
    setProductName(value);

    const selectedProduct = productData.find((p) => p.PRODNAME === value);

    if (selectedProduct) {
      setRate(selectedProduct.RATE || 0);
      setQty(1);
      const amt = 1 * selectedProduct.RATE;
      setAmount(amt || 0);
      setDisCount(0);
      setDisAmt(0);

      setHsnCode(selectedProduct.HSNCODE || "");
      setBrandName(selectedProduct.BRANDNAME || "");
      setPTypeName(selectedProduct.PTYPE || "");
      setTimeout(() => {
        designRef?.current?.focus();
      }, 0);
    } else {
      setRate(0);
      setQty(0);
      setDisCount(0);
      setDisAmt(0);
      setHsnCode("");
      setBrandName("");
      setPTypeName("");
      setAmount(0);
    }
  };

  const handleKeyDown = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextRef?.current) {
        nextRef.current.focus();
      }
    }
  };

  return (
    <Modal
      className="hb-modal"
      title={<div className="hb-title">Product Details</div>}
      open={homeDetailsOpen}
      //   onCancel={handelCancel}
      closable={false}
      //   onOk={handelCancel}
      //   okText="OK"
      //   cancelText="Cancel"
      maskStyle={{
        backdropFilter: "blur(8px)",
        backgroundColor: "rgba(0, 0, 0, 0.2)",
      }}
      afterOpenChange={(open) => {
        if (open && productRef.current) {
          productRef.current.focus();
        }
      }}
      footer={null}
    >
      {/* ---------- embedded styles (single file) ---------- */}
      <style>{`
        .hb-modal .ant-modal-content{padding:0;border-radius:18px;overflow:hidden}
        .hb-modal .ant-modal-header{margin:0;padding:0;background:transparent}
        .hb-modal .ant-modal-body{padding:14px;background:#eef1f8}

        .hb-title{background:linear-gradient(135deg,#114a3d,#1f8f6a);color:#fff;font-weight:800;font-size:16px;text-align:center;padding:14px 12px;letter-spacing:.4px}

        .hb-code{display:flex;align-items:center;justify-content:space-between;background:linear-gradient(135deg,#162566,#2a3c8f);color:#fff;border-radius:14px;padding:10px 14px;box-shadow:0 4px 12px rgba(22,37,102,.3)}
        .hb-code-l{font-size:11px;font-weight:700;text-transform:uppercase;opacity:.85}
        .hb-chip{background:linear-gradient(180deg,#ffd666,#f2b01e);color:#3b2a00;font-weight:800;font-size:17px;padding:4px 14px;border-radius:10px}

        .hb-card{background:#fff;border:1.5px solid #e1e6f4;border-radius:14px;padding:8px 12px 10px;box-shadow:0 1px 4px rgba(0,0,0,.05)}
        .hb-label{font-size:11px;font-weight:800;color:#6b76a8;text-transform:uppercase;letter-spacing:.5px;margin-bottom:4px}
        .hb-input{height:40px;border-radius:10px!important;font-size:16px;font-weight:700;color:#162566;width:100%}
        .hb-select{width:100%}
        .hb-select .ant-select-selector{min-height:40px;border-radius:10px!important;align-items:center}

        .hb-grid{margin-top:10px;display:grid;grid-template-columns:1fr 1fr;gap:10px}
        .hb-grid-top{margin-top:10px}

        .hb-result{margin-top:10px;display:grid;grid-template-columns:1fr 1fr;gap:10px}
        .hb-tile{border-radius:14px;padding:10px 12px;color:#fff}
        .hb-tile.act{background:linear-gradient(135deg,#ffb020,#f08a00)}
        .hb-tile.amt{background:linear-gradient(135deg,#1f8f6a,#52bd91)}
        .hb-tile-l{font-size:11px;font-weight:700;text-transform:uppercase;opacity:.9}
        .hb-tile-v{font-size:20px;font-weight:800;margin-top:2px}

        .hb-actions{margin-top:12px;display:grid;grid-template-columns:1fr 1fr;gap:10px}
        .hb-btn{height:44px!important;border-radius:12px!important;font-weight:800!important;font-size:14px!important}
        .hb-cancel{background:#fff!important;border:1.5px solid #BF092F!important;color:#BF092F!important}
        .hb-save{background:linear-gradient(135deg,#1f8f6a,#52bd91)!important;border:0!important;color:#fff!important}
        .hb-save:disabled{opacity:.5}
      `}</style>

      {/* Design code */}
      <div className="hb-code">
        <span className="hb-code-l">Design Code</span>
        <span className="hb-chip">{designCode || "-"}</span>
      </div>

      {/* Product name */}
      <div className="hb-card hb-grid-top">
        <div className="hb-label">Product Name</div>
        <Select
          allowClear
          showSearch
          className="hb-select"
          placeholder="Select Product"
          style={{ textAlign: "left" }}
          ref={productRef}
          value={productName || null}
          onChange={handleProductChange}
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              const inputText = e.target.value?.toLowerCase() || "";
              const filtered = productData.filter((m) =>
                m.PRODNAME.toLowerCase().includes(inputText),
              );

              if (filtered.length > 0) {
                const selected = filtered[0].PRODNAME;
                handleProductChange(selected);
                setTimeout(() => {
                  designRef?.current?.focus();
                }, 0);
              }
            }
          }}
        >
          {productData.map((pro, index) => (
            <Option key={index} value={pro.PRODNAME}>
              {pro.PRODNAME}
            </Option>
          ))}
        </Select>
      </div>

      {/* Qty / Rate */}
      <div className="hb-grid">
        <div className="hb-card">
          <div className="hb-label">Qty</div>
          <Input
            placeholder="Enter Qty"
            className="hb-input"
            ref={designRef}
            disabled={!productName}
            inputMode="decimal"
            value={qty}
            onFocus={(e) => e.target.select()}
            onChange={(e) => {
              const val = e.target.value;

              if (/^\d*\.?\d{0,2}$/.test(val)) {
                const amt = val * rate;

                setQty(val);
              }
            }}
            onKeyDown={(e) => {
              handleKeyDown(e, rateRef);
            }}
          />
        </div>

        <div className="hb-card">
          <div className="hb-label">Rate</div>
          <Input
            placeholder="Enter Rate"
            className="hb-input"
            ref={rateRef}
            disabled={!productName}
            inputMode="decimal"
            value={rate}
            onFocus={(e) => e.target.select()} // Select entire value
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d*\.?\d{0,2}$/.test(val)) {
                const disPer = disCount;
                const rateValue = val * disPer;
                const dAmt = rateValue / 100;
                const ActRate = val - dAmt;

                setRate(val);
                setDisAmt(dAmt);
                setAmount(ActRate);
              }
            }}
            onKeyDown={(e) => {
              handleKeyDown(e, disPerRef);
            }}
          />
        </div>

        {/* Dis Per / Dis Amt */}
        <div className="hb-card">
          <div className="hb-label">Dis Per (%)</div>
          <Input
            placeholder="Enter Dis Per"
            className="hb-input"
            ref={disPerRef}
            disabled={!productName}
            inputMode="decimal"
            value={disCount}
            onFocus={(e) => e.target.select()} // Select entire value
            onChange={(e) => {
              const val = e.target.value;
              if (!/^\d*\.?\d*$/.test(val)) return;
              const updatedValue = val === 0 ? 0 : Number(val);
              const cRate = rate;
              const rateValue = cRate * val;
              const disAmt = rateValue / 100;
              const ActRate = cRate - disAmt;

              setDisCount(updatedValue);
              setDisAmt(disAmt);
              setAmount(ActRate);
            }}
            onKeyDown={(e) => {
              handleKeyDown(e, disAmtRef);
            }}
          />
        </div>

        <div className="hb-card">
          <div className="hb-label">Dis Amt</div>
          <Input
            placeholder="Enter Dis Amt"
            className="hb-input"
            ref={disAmtRef}
            disabled={!productName}
            inputMode="decimal"
            value={disAmt ?? 0}
            onFocus={(e) => e.target.select()} // Select entire value
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d*\.?\d{0,2}$/.test(val)) {
                const rateValue = rate;
                const ActRate = rateValue - val;

                setDisAmt(val);
                setAmount(ActRate);
              }
            }}
            onKeyDown={(e) => {
              handleKeyDown(e, saveRef);
            }}
          />
        </div>
      </div>

      {/* Act Rate / Amount (read-only) */}
      <div className="hb-result">
        <div className="hb-tile act">
          <div className="hb-tile-l">Act Rate</div>
          <div className="hb-tile-v">{Number(amount)?.toFixed(2)}</div>
        </div>
        <div className="hb-tile amt">
          <div className="hb-tile-l">Amount</div>
          <div className="hb-tile-v">{Number(qty * amount)?.toFixed(2)}</div>
        </div>
      </div>

      {/* Actions */}
      <div className="hb-actions">
        <Button
          className="hb-btn hb-cancel"
          onClick={() => {
            handelCancel();
          }}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          className="hb-btn hb-save"
          ref={saveRef}
          disabled={!productName || rate <= 0}
          onClick={() => {
            handleHomeBillSave();
          }}
        >
          Save
        </Button>
      </div>
    </Modal>
  );
};
export default HomeBillDialog;